import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { makeStyles } from "tss-react/mui";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import TableWithStickHeader from "../../../../Common/Table/TableWithStickHeader";
import { KMKDialog } from "../../../../Common";

const columns = [
  { id: "Stage", label: "Stage", width: "120px", align: "left" },
  { id: "Message", label: "Message", width: "420px", align: "left" },
];

const useStyles = makeStyles()((theme) => ({
  dialogPaper: {
    "& .MuiPaper-root.MuiDialog-paper": {
      maxWidth: "960px",
      width: "960px",
    },
  },
  formContainer: {
    display: "grid",
    width: "100%",
    textAlign: "left",
    minHeight: "100px",
  },
  container: {
    padding: "24px 24px 24px 24px",
    backgroundColor: "#FFFFFF",
    minHeight: "100px",
  },
  Toolbar: {
    width: "100%",
    fontSize: "1.1rem",
    backgroundColor: "white",
    color: "black",
  },
}));

export default function DataLoadErrorLog({ configData }) {
  const [errorList, setErrorList] = useState([]);
  const { classes } = useStyles();

  useEffect(() => {
    let errorDataArr = [];

    configData.jobErrorList.length &&
      configData.jobErrorList.forEach((row) => {
        errorDataArr.push([
          { value: row.Stage, align: "left" },
          {
            value: row.Message,
            align: "left",
          },
        ]);
      });

    setErrorList(errorDataArr);
    return () => {
      setErrorList([]);
    };
  }, [configData.jobErrorList]);

  return (
    <KMKDialog className={classes.dialogPaper} open={configData.open} onClose={() => configData.handleCancel()}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar className={classes.Toolbar}>{configData.popupTitle} </Toolbar>
        <IconButton
          aria-label="close"
          onClick={() => configData.handleCancel()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
      </AppBar>
      <Box sx={{ width: "100%" }} className={classes.container}>
        <Box sx={{ width: "100%" }} component="form" className={classes.formContainer}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <TableWithStickHeader
                {...{
                  columns: columns,
                  tableData: errorList,
                  tableMaxWidth: "912px",
                  tableMaxHeight: "350px",
                  noDataColspan: 2,
                  noDataMessage: "No error found",
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </KMKDialog>
  );
}
